<micro-select-combo #sel
              placeholder="Object.Type"
              [mode]="mode"
              [(id)]="entityType"
              (idChange)="change($event)"
              [options]="options"
              [required]="required"
              [disabled]="disabled"
              valueField="id"
>
</micro-select-combo>
